
if (!customElements.get('damastringe-whatsapp-contact')) {
  customElements.define('damastringe-whatsapp-contact', class extends HTMLElement {
    connectedCallback() {
      this.initialize = () => {
        const button = this.querySelector('.damastringe-whatsapp');
        const footer = document.querySelector('footer.shopify-section--footer');
        if (!button || !footer) return;
        const rect = footer.getBoundingClientRect();
        button.toggleAttribute('data-footer-visible', rect.top < window.innerHeight && rect.bottom > 0);
        this.observer = new IntersectionObserver(entries => {
          button.toggleAttribute('data-footer-visible', entries[0].isIntersecting);
        });
        this.observer.observe(footer);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
      } else {
        this.initialize();
      }
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.initialize);
      this.observer?.disconnect();
    }
  });
}

;

if (!customElements.get('dm-gravur-controller')) {
customElements.define('dm-gravur-controller', class extends HTMLElement {
connectedCallback() {
if (this.started) return;
this.started = true;
this.abort = new AbortController();
this.start = () => this.initialize();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',this.start,{once:true,signal:this.abort.signal});
else this.start();
}
initialize() {
const main = document.getElementById('main');
const template = this.querySelector('[data-gravur-template]');
if (!main || !template) return;
this.ui = template.content.firstElementChild.cloneNode(true);
this.toggle = this.ui.querySelector('[data-gravur-toggle]');
this.textInput = this.ui.querySelector('[data-gravur-input]');
this.fields = this.ui.querySelector('.dm-gravur-fields');
this.preview = this.ui.querySelector('.dm-gravur-text');
this.state = this.ui.querySelector('.dm-gravur-state');
this.total = this.ui.querySelector('.dm-gravur-total');
this.error = this.ui.querySelector('[data-gravur-error]');
this.checkoutNote = this.ui.querySelector('.dm-gravur-checkout-note');
this.serviceId = Number(this.dataset.serviceId);
this.servicePrice = Number(this.dataset.servicePrice);
this.money = new Intl.NumberFormat(document.documentElement.lang || 'de',{style:'currency',currency:this.dataset.currency || 'EUR'});
this.ringView = this.ui.querySelector('dm-gravur-ring-view');
this.ui.querySelector('.dm-gravur-enlarge')?.addEventListener('click',() => document.dispatchEvent(new CustomEvent('dm-gravur:preview',{detail:{items:[this.previewItem()]}})),{signal:this.abort.signal});
const choices = this.ui.querySelector('.dm-gravur-choices');
this.choices = [...choices.children].sort((a,b) => Number(a.dataset.fontOrder) - Number(b.dataset.fontOrder));
choices.replaceChildren(...this.choices);
this.forms = new WeakSet();
this.fonts = [];
this.choices.forEach(choice => {
const input = choice.querySelector('input');
choice.querySelector('.dm-gravur-sample').style.fontFamily = '"' + choice.dataset.fontFamily + '"';
input.addEventListener('change',() => {this.selected = choice; this.sync();},{signal:this.abort.signal});
});
this.toggle.addEventListener('change',() => {
if (this.toggle.checked) this.loadFonts();
this.sync();
},{signal:this.abort.signal});
this.textInput.addEventListener('input',() => this.sync(),{signal:this.abort.signal});
main.addEventListener('change',() => this.sync(),{signal:this.abort.signal});
main.addEventListener('input',event => {if (event.target.name === 'quantity') this.sync();},{signal:this.abort.signal});
main.addEventListener('click',event => {
const submit = event.target.closest('[type="submit"]');
if (submit && this.form?.contains(submit)) this.guard(event);
},{capture:true,signal:this.abort.signal});
this.observer = new MutationObserver(records => {
if (records.every(record => this.ui.contains(record.target))) return;
this.sync();
});
this.observer.observe(main,{childList:true,characterData:true,subtree:true});
this.sync();
if (this.toggle.checked) this.loadFonts();
}
loadFonts() {
if (this.fontLoadStarted) return;
this.fontLoadStarted = true;
const fontLoads = this.choices.map(choice => {
const family = choice.dataset.fontFamily;
const font = new FontFace(family,'url(' + JSON.stringify(choice.dataset.fontUrl) + ')');
this.fonts.push(font);
return font.load().then(loaded => {
if (this.abort.signal.aborted) return;
document.fonts.add(loaded);
choice.dataset.loaded = 'true';
this.sync();
}).catch(() => {choice.hidden = true; this.sync();});
});
Promise.allSettled(fontLoads).then(() => {
if (this.abort.signal.aborted) return;
this.fontsSettled = true;
this.selected ||= this.choices.find(choice => choice.dataset.loaded === 'true');
this.sync();
});
}
guard(event) {
this.sync();
if (!this.toggle.checked) return;
if (!this.textInput.reportValidity()) {
event.preventDefault();
event.stopImmediatePropagation();
return;
}
if (this.selected?.dataset.loaded !== 'true') {
event.preventDefault();
event.stopImmediatePropagation();
this.state.textContent = this.fontsSettled ? 'Die Schriften konnten nicht geladen werden. Bitte lade die Seite erneut.' : 'Bitte warte, bis die Schriften geladen sind.';
return;
}
if (!this.serviceId || this.dataset.serviceAvailable !== 'true') {
event.preventDefault();
event.stopImmediatePropagation();
this.error.hidden = false;
this.error.textContent = 'Die Gravur ist gerade nicht verfügbar. Bitte versuche es später erneut.';
return;
}
if (event.type === 'submit') {
event.preventDefault();
event.stopImmediatePropagation();
if (!this.adding) this.addEngraved();
}
}
async addEngraved() {
this.adding = true;
this.error.hidden = true;
const buttons = [...this.form.elements].filter(el => el.type === 'submit');
buttons.forEach(button => button.setAttribute('aria-busy','true'));
document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start',{bubbles:true}));
try {
const data = new FormData(this.form);
const id = Number(data.get('id'));
const quantity = Number(data.get('quantity') || 1);
if (!id || !Number.isInteger(quantity) || quantity < 1) throw new Error('Bitte prüfe die Ringauswahl und die Anzahl.');
const pair = crypto.randomUUID();
const properties = {};
for (const [key,value] of data) {
const match = key.match(/^properties\[(.+)\]$/);
if (match) properties[match[1]] = value;
}
properties._dm_gravur_pair = pair;
properties._dm_gravur_kind = 'ring';
Object.assign(properties,this.previewProperties());
const ring = {id,quantity,properties};
if (data.get('selling_plan')) ring.selling_plan = data.get('selling_plan');
const sections = [];
document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
const response = await fetch(Shopify.routes.root + 'cart/add.js',{
method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
body:JSON.stringify({items:[ring,{id:this.serviceId,quantity,parent_id:id,properties:{_dm_gravur_pair:pair,_dm_gravur_kind:'fee',Für:this.dataset.productTitle}}],sections:sections.join(','),sections_url:window.location.pathname})
});
const added = await response.json();
if (!response.ok) throw new Error(added.description || 'Der Ring konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
const cartResponse = await fetch(Shopify.routes.root + 'cart.js');
if (!cartResponse.ok) {window.location.assign(Shopify.routes.root + 'cart');return;}
const cart = await cartResponse.json();
cart.sections = added.sections;
document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
if (!document.querySelector('cart-drawer')) window.location.assign(Shopify.routes.root + 'cart');
} catch (error) {
this.error.textContent = error.message || 'Bitte versuche es erneut.';
this.error.hidden = false;
} finally {
this.adding = false;
buttons.forEach(button => button.removeAttribute('aria-busy'));
document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end',{bubbles:true}));
}
}
sync() {
const main = document.getElementById('main');
const form = main?.querySelector('product-form form[action*="/cart/add"]:has([type="submit"])');
if (form && form.previousElementSibling !== this.ui) form.before(this.ui);
this.ui.hidden = !form;
if (form && this.form !== form) {
this.properties?.forEach(input => input.remove());
this.form = form;
this.textInput.setAttribute('form',form.id);
this.properties = ['Gravur','Gravurtext','Gravurschrift'].map(name => {
const input = document.createElement('input');
input.type = 'hidden';
input.name = 'properties[' + name + ']';
input.disabled = true;
form.append(input);
return input;
});
}
if (form && !this.forms.has(form)) {
this.forms.add(form);
form.addEventListener('submit',event => this.guard(event),{capture:true,signal:this.abort.signal});
}
const active = Boolean(form && this.toggle.checked);
this.total.hidden = !active;
this.checkoutNote.hidden = !active;
let selectedRing;
try { selectedRing = JSON.parse(main?.querySelector('variant-picker[context="main_product"] script[data-variant]')?.textContent || '{}'); } catch { selectedRing = {}; }
const sharedProduct = main?.querySelector('dm-shared-pendant-band');
if (!selectedRing.id && sharedProduct) selectedRing={id:Number(sharedProduct.dataset.baseId),price:Number(sharedProduct.dataset.basePrice)};
const ringPrice = selectedRing.id ? Number(selectedRing.price) : NaN;
if (Number.isFinite(ringPrice) && form) {
const displayText = this.money.format((ringPrice + (active ? this.servicePrice : 0))/100);
for (const priceElement of main.querySelectorAll('product-rerender[observe-form] price-list sale-price')) {
if (priceElement.closest('product-rerender').getAttribute('observe-form') !== form.getAttribute('id')) continue;
let display = priceElement.querySelector('[data-dm-display-price]');
if (!display) {
display = document.createElement('span');
display.dataset.dmDisplayPrice = '';
[...priceElement.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
priceElement.append(display);
}
if (display.textContent !== displayText) display.textContent = displayText;
}
}
const quantityInput = form ? [...form.elements].find(el => el.name === 'quantity') : null;
const quantity = Number(quantityInput?.value || 1);
const itemLabel=this.dataset.itemLabel || 'Ring';
const totalText = Number.isFinite(ringPrice) ? 'Gesamt pro '+itemLabel+': ' + this.money.format((ringPrice + this.servicePrice)/100) + (quantity > 1 ? ' · ' + quantity + ' '+(itemLabel==='Ring'?'Ringe':'Anhänger')+': ' + this.money.format((ringPrice + this.servicePrice)*quantity/100) : '') : 'Gravur: + ' + this.money.format(this.servicePrice/100) + ' je '+itemLabel;
if (this.total.textContent !== totalText) this.total.textContent = totalText;
this.fields.hidden = !active;
this.toggle.setAttribute('aria-expanded',String(active));
this.textInput.disabled = !active;
this.textInput.required = active;
this.textInput.setCustomValidity(active && !this.textInput.value.trim() ? 'Bitte gib deinen Gravurtext ein.' : '');
this.choices.forEach(choice => {
const radio = choice.querySelector('input');
radio.disabled = !active || choice.dataset.loaded !== 'true';
radio.checked = choice === this.selected;
});
const sample = this.textInput.value || (this.dataset.previewMode==='dogtag-front-v1' ? 'Lena und Dirk\nDeine Botschaft\nDein Datum' : 'Lena und Dirk');
if (this.preview.textContent !== sample) this.preview.textContent = sample;
const family = this.selected?.dataset.fontFamily;
const desiredFamily = family ? '"' + family + '"' : '';
if (this.preview.style.fontFamily !== desiredFamily) this.preview.style.fontFamily = desiredFamily;
if (this.ringView && active) {
const values = {image:this.dataset.productImage,text:sample,font:desiredFamily,mode:this.dataset.previewMode};
for (const [key,value] of Object.entries(values)) if (this.ringView.getAttribute('data-'+key) !== value) this.ringView.setAttribute('data-'+key,value);
}
const selectedName = this.selected?.querySelector('input').value || '';
const state = !this.selected ? this.fontsSettled ? 'Die Schriften konnten nicht geladen werden. Bitte lade die Seite erneut.' : 'Schriften werden geladen …' : this.textInput.value ? selectedName : 'Beispiel · Gib oben deinen Gravurtext ein.';
if (this.state.textContent !== state) this.state.textContent = state;
const values = ['Ja, mit Gravur',this.textInput.value,selectedName];
this.properties?.forEach((input,i) => {
const enabled = active && Boolean(this.textInput.value.trim()) && this.selected?.dataset.loaded === 'true';
input.value = enabled ? values[i] : '';
input.disabled = !enabled;
});
}
previewProperties() {
return {_dm_gravur_image:this.dataset.productImage,_dm_gravur_view:this.dataset.previewMode,_dm_gravur_font_url:this.selected?.dataset.fontUrl || '',_dm_gravur_font_family:this.selected?.dataset.fontFamily || ''};
}
previewItem() {
let options = [...document.querySelectorAll('#main variant-picker button')].map(button => button.textContent.trim()).filter(text => this.dataset.previewMode==='midgard-lower-v1' || /Ø|mm|Ohne Diamant|Lederband|Schlüsselanhänger/.test(text));
try {
const variant = JSON.parse(document.querySelector('#main variant-picker script[data-variant]')?.textContent || '{}');
if (Array.isArray(variant.options)) options = variant.options;
} catch {}
const sharedBand=document.querySelector('#main dm-shared-pendant-band input:checked');
if(sharedBand) options=[sharedBand.value];
return {product_title:this.dataset.productTitle,variant_title:options.join(' / '),quantity:1,properties:{Gravurtext:this.textInput.value || (this.dataset.previewMode==='dogtag-front-v1'?'Lena und Dirk\nDeine Botschaft\nDein Datum':'Lena und Dirk'),Gravurschrift:this.selected?.querySelector('input').value || '',...this.previewProperties()}};
}
disconnectedCallback() {
this.abort?.abort();
this.observer?.disconnect();
this.ui?.remove();
this.properties?.forEach(input => input.remove());
this.fonts?.forEach(font => document.fonts.delete(font));
this.fontLoadStarted = false;
this.fontsSettled = false;
this.selected = null;
this.started = false;
}
});
}

;

if (!customElements.get('dm-selection-price')) {
  customElements.define('dm-selection-price',class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.abort = new AbortController();
      this.start = () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',this.start,{once:true,signal:this.abort.signal});
      else this.start();
    }
    initialize() {
      const main = document.getElementById('main');
      if (!main) return;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'de',{style:'currency',currency:this.dataset.currency || 'EUR'});
      this.cards = new Map();
      const schedule = () => {
        if (this.scheduled) return;
        this.scheduled = true;
        queueMicrotask(() => {this.scheduled=false;if (!this.abort.signal.aborted) this.sync();});
      };
      main.addEventListener('variant:change',schedule,{signal:this.abort.signal});
      main.addEventListener('change',schedule,{signal:this.abort.signal});
      this.observer = new MutationObserver(records => {
        if (records.every(record => record.target.closest?.('.dm-selection-price'))) return;
        schedule();
      });
      this.observer.observe(main,{childList:true,characterData:true,subtree:true});
      this.sync();
    }
    sync() {
      const main = document.getElementById('main');
      if (!main) return;
      const controller = document.querySelector('dm-gravur-controller[data-service-price]');
      const engraving = Boolean(main.querySelector('[data-gravur-toggle]:checked'));
      const surcharge = engraving ? Number(controller?.dataset.servicePrice || 0) : 0;
      for (const [picker,card] of this.cards) if (!picker.isConnected) {card.remove();this.cards.delete(picker);}
      for (const picker of main.querySelectorAll('variant-picker[context="main_product"]')) {
        let variant;
        try {variant = JSON.parse(picker.querySelector('script[data-variant]')?.textContent || '{}');} catch {variant = {};}
        const price = Number(variant.price);
        let card = this.cards.get(picker);
        if (!Number.isFinite(price) || !variant.id) {
          card?.remove();this.cards.delete(picker);picker.classList.remove('dm-priced-picker');continue;
        }
        if (!card) {
          card = this.querySelector('template').content.firstElementChild.cloneNode(true);
          picker.append(card);picker.classList.add('dm-priced-picker');this.cards.set(picker,card);
        }
        const text = this.money.format((price+surcharge)/100);
        const value = card.querySelector('.dm-selection-price__value');
        if (value.textContent !== text) value.textContent = text;
        const productInfo = picker.closest('product-rerender');
        const priceElement = productInfo?.querySelector('price-list.price-list--product sale-price');
        if (priceElement) {
          let display = priceElement.querySelector('[data-dm-display-price]');
          if (!display) {
            display = document.createElement('span');
            display.dataset.dmDisplayPrice = '';
            [...priceElement.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
            priceElement.append(display);
          }
          if (display.textContent !== text) display.textContent = text;
        }
      }
    }
    disconnectedCallback() {
      this.abort?.abort();this.observer?.disconnect();
      this.cards?.forEach((card,picker) => {card.remove();picker.classList.remove('dm-priced-picker');});
      this.started = false;
    }
  });
}

;

if (!customElements.get('dm-ring-width-preview')) {
  customElements.define('dm-ring-width-preview',class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.originals = new WeakMap();
      this.loaded = new Map();
      this.version = 0;
      this.images = JSON.parse(this.querySelector('[data-width-images]').textContent);
      const start = () => {
        this.main = document.getElementById('main');
        if (!this.main) return;
        const schedule = () => {
          if (this.scheduled) return;
          this.scheduled = true;
          queueMicrotask(() => {this.scheduled=false;if (!this.abort.signal.aborted) this.sync();});
        };
        this.main.addEventListener('variant:change',schedule,{signal:this.abort.signal});
        this.observer = new MutationObserver(records => {
          if (records.every(record => record.target.closest?.('.dm-ring-width-note'))) return;
          schedule();
        });
        this.observer.observe(this.main,{childList:true,subtree:true});
        this.sync();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true,signal:this.abort.signal});
      else start();
    }
    async sync() {
      const picker = this.main.querySelector('variant-picker[context="main_product"][handle="sonnensturmkaiser"]');
      if (!picker) return;
      const gallery = this.main.querySelector('product-gallery[form="'+picker.getAttribute('form-id')+'"]');
      const photo = gallery?.querySelector('.product-gallery__media[data-media-type="image"] img');
      if (!photo) return;
      let variant;
      try {variant = JSON.parse(picker.querySelector('script[data-variant]')?.textContent || '{}');} catch {return;}
      const width = parseInt(variant.option2,10);
      const url = this.images[String(width)];
      if (this.photo === photo && this.width === width) return;
      this.photo = photo;
      this.width = width;
      const version = ++this.version;
      if (!this.originals.has(photo)) this.originals.set(photo,Object.fromEntries(['src','srcset','sizes','alt','width','height'].map(key => [key,photo.getAttribute(key)])));
      const restore = () => {
        for (const [key,value] of Object.entries(this.originals.get(photo))) {
          if (value === null) photo.removeAttribute(key);
          else photo.setAttribute(key,value);
        }
        photo.removeAttribute('data-dm-width');
      };
      let note = gallery.querySelector('.dm-ring-width-note');
      if (!url) {restore();note?.remove();return;}
      if (!note) {
        note = document.createElement('p');
        note.className = 'dm-ring-width-note';
        note.setAttribute('role','status');
        gallery.querySelector('.product-gallery__image-list').append(note);
      }
      note.textContent = 'Breitenvorschau wird geladen …';
      try {
        if (!this.loaded.has(url)) {
          const image = new Image();
          image.src = url+'?width=1000';
          this.loaded.set(url,image.decode().then(() => image));
        }
        await this.loaded.get(url);
        if (version !== this.version || !photo.isConnected || this.abort.signal.aborted) return;
        photo.srcset = [200,400,600,800,1000].map(size => url+'?width='+size+' '+size+'w').join(', ');
        photo.src = url+'?width=1000';
        photo.setAttribute('width','1000');
        photo.setAttribute('height','1000');
        photo.alt = 'SonnenSturmKaiser – '+width+' mm, optische Breitenvorschau';
        photo.dataset.dmWidth = String(width);
        note.textContent = 'Breitenvorschau · '+width+' mm · optischer Test, nicht maßstabsgetreu';
      } catch {
        if (version !== this.version || this.abort.signal.aborted) return;
        this.loaded.delete(url);
        restore();
        note.textContent = 'Originalfoto · Breitenvorschau derzeit nicht verfügbar';
      }
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();++this.version;}
  });
}

;

if (!customElements.get('dm-ringmeasure')) {
  customElements.define('dm-ringmeasure',class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.abort = new AbortController();
      this.start = () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',this.start,{once:true,signal:this.abort.signal});
      else this.start();
    }
    initialize() {
      const main = document.getElementById('main');
      this.panel = this.querySelector('.dm-ringmeasure-panel');
      if (!main || !this.panel) return;
      this.form = this.panel.querySelector('form');
      this.toggle = this.panel.querySelector('[data-ringmeasure-toggle]');
      this.request = this.panel.querySelector('.dm-ringmeasure-request');
      this.address = this.panel.querySelector('[data-ringmeasure-address]');
      this.emailPanel = this.panel.querySelector('[data-ringmeasure-email-panel]');
      this.email = this.panel.querySelector('[data-ringmeasure-email]');
      this.emailButton = this.panel.querySelector('[data-ringmeasure-channel="email"]');
      this.whatsapp = this.panel.querySelector('[data-ringmeasure-channel="whatsapp"]');
      this.messageInput = this.panel.querySelector('[data-ringmeasure-message]');
      this.returnInput = this.form.querySelector('[name="return_to"]');
      try {this.optionNames=JSON.parse(this.dataset.optionNames || '[]');} catch {this.optionNames=[];}
      this.toggle.addEventListener('change',() => this.sync(),{signal:this.abort.signal});
      this.address.addEventListener('input',() => {
        this.address.setCustomValidity('');
        this.updateMessage();
      },{signal:this.abort.signal});
      this.whatsapp.addEventListener('click',event => {
        if (!this.validAddress()) {event.preventDefault();return;}
        this.updateMessage();
      },{signal:this.abort.signal});
      this.emailButton.addEventListener('click',event => {
        if (this.emailPanel.hidden) {
          event.preventDefault();
          if (!this.validAddress()) return;
          this.emailPanel.hidden=false;
          this.email.required=true;
          this.emailButton.type='submit';
          this.emailButton.textContent='E-Mail jetzt senden';
          this.emailButton.setAttribute('aria-expanded','true');
          this.email.focus();
        }
      },{signal:this.abort.signal});
      this.form.addEventListener('submit',event => {
        if (!this.validAddress()) {event.preventDefault();return;}
        this.updateMessage();
      },{signal:this.abort.signal});
      const schedule = () => {
        if (this.scheduled) return;
        this.scheduled = true;
        queueMicrotask(() => {this.scheduled=false;if (!this.abort.signal.aborted) this.sync();});
      };
      main.addEventListener('variant:change',schedule,{signal:this.abort.signal});
      main.addEventListener('change',schedule,{signal:this.abort.signal});
      main.addEventListener('input',schedule,{signal:this.abort.signal});
      this.observer = new MutationObserver(schedule);
      this.observer.observe(main,{childList:true,subtree:true});
      if (this.panel.querySelector('.dm-ringmeasure-error')) {
        this.toggle.checked=true;
        this.emailPanel.hidden=false;
        this.emailButton.type='submit';
        this.emailButton.textContent='E-Mail jetzt senden';
        this.emailButton.setAttribute('aria-expanded','true');
      }
      this.sync();
      this.panel.querySelector('.dm-ringmeasure-success')?.focus({preventScroll:false});
    }
    validAddress() {
      this.address.setCustomValidity(this.address.value.trim() ? '' : 'Trag bitte deinen Namen und deine Versandadresse ein.');
      if (this.address.validity.valid) return true;
      this.address.reportValidity();
      this.address.focus();
      return false;
    }
    updateMessage() {
      const picker = document.querySelector('#main variant-picker[context="main_product"]');
      let variant={};
      try {variant=JSON.parse(picker?.querySelector('script[data-variant]')?.textContent || '{}');} catch {}
      const options=variant.options || [variant.option1,variant.option2,variant.option3].filter(Boolean);
      const details=options.map((value,index) => (this.optionNames[index] || 'Ausführung') + ': ' + value);
      const productForm=document.getElementById(picker?.getAttribute('form-id') || '');
      const quantity=productForm ? [...productForm.elements].find(input=>input.name==='quantity')?.value : null;
      if (quantity) details.push('Anzahl: ' + quantity);
      const engraving=document.querySelector('#main [data-gravur-toggle]:checked');
      details.push('Gravur: ' + (engraving ? 'Ja' : 'Nein'));
      if (engraving) {
        const text=document.querySelector('#main [data-gravur-input]')?.value?.trim();
        const font=document.querySelector('#main .dm-gravur-choices input:checked')?.value;
        if (text) details.push('Gravurtext: ' + text);
        if (font) details.push('Gravurschrift: ' + font);
      }
      const displayedPrice=document.querySelector('#main .dm-selection-price__value')?.textContent?.trim();
      if (displayedPrice) details.push('Angezeigter Preis: ' + displayedPrice);
      const url=new URL(this.dataset.productUrl,window.location.origin);
      if (variant.id) url.searchParams.set('variant',String(variant.id));
      const message='Hallo Dirk, bitte schick mir ein kostenloses Ringmaß.\n\nMeine Versandadresse:\n' + this.address.value.trim() + '\n\nMein Wunschring: ' + this.dataset.productTitle + '\nAktuelle Auswahl (unverbindlich):\n' + details.join('\n') + '\n\nProdukt: ' + url.href + '\n\nDies ist eine kostenlose Ringmaß-Anfrage, keine Ringbestellung.\nVielen Dank!';
      const href='https://wa.me/4917624799575?text=' + encodeURIComponent(message);
      if (this.whatsapp.href !== href) this.whatsapp.href=href;
      this.messageInput.value=message;
      url.searchParams.set('contact_posted','true');
      url.hash='dm-ringmeasure-confirmation';
      this.returnInput.value=url.pathname + url.search + url.hash;
    }
    sync() {
      const picker = document.querySelector('#main variant-picker[context="main_product"]');
      if (picker && (!this.panel.isConnected || this.panel.parentElement !== picker.parentElement)) picker.before(this.panel);
      this.panel.hidden = !picker;
      const enabled = this.toggle.checked;
      this.request.hidden = !enabled;
      this.toggle.setAttribute('aria-expanded',String(enabled));
      this.address.required=enabled;
      this.email.required=enabled && !this.emailPanel.hidden;
      if (!enabled) this.address.setCustomValidity('');
      this.updateMessage();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.panel?.remove();
      this.started = false;
    }
  });
}
